import "./skills.scss";
import { withStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import {skillsData} from '../../skills';

export default function Skills(){

    const SkillsBar = withStyles((theme) => ({
        root: {
            height: 10,
            borderRadius: 5,
        },
        colorPrimary: {
            // backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
            backgroundColor: "grey",
        },
        bar: {
            borderRadius: 5,
            backgroundColor: "crimson",
        },
        }))(LinearProgress);

    // const textRef = useRef();

    // useEffect(() => {
    //     init(textRef.current, { 
    //         showCursor: false, 
    //         strings: ['Software Developer']
    //     });
    // }, []);

    return(
        <div className="skills" id="skills">
            <h1>Skills</h1>
            <div className="container">

                {
                    skillsData.map((sd) => {
                        return(
                            <div className="card">
                                <div className="center">
                                    <h3>{sd.name}</h3>
                                    <SkillsBar variant="determinate" value={sd.rating}/>
                                </div>
                            </div>
                        );
                    })
                }
                
            </div>

          
        </div>
    );
}